import gql from "graphql-tag";

const IS_LOGGED_IN = gql`
  query isLoggedIn {
    isLoggedIn
  }
`;

export default IS_LOGGED_IN;
